import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["renderSimplePricing", "renderSearchTrending"];

  connect() {
    this.simplePricing();
    this.searchTrending();
  }

  simplePricing() {
    const simplePricingData = JSON.parse(this.data.get("simplePricing"));
    const formatSimplePricingData = JSON.stringify(simplePricingData, undefined, 2);
    this.renderSimplePricingTarget.textContent = formatSimplePricingData;
  }

  searchTrending() {
    const searchTrendingData = JSON.parse(this.data.get("searchTrending"));
    const formatSearchTrendingData = JSON.stringify(searchTrendingData, undefined, 2);
    this.renderSearchTrendingTarget.textContent = formatSearchTrendingData;
  }

  toggleFaq(event) {
    const question = event.currentTarget;
    const icon = question.firstElementChild;
    const answer = question.parentNode.nextElementSibling;

    if (answer.classList.contains("tw-hidden")) {
      this._showFaqAnswer(icon, answer);
    } else {
      this._hideFaqAnswer(icon, answer);
    }
  }

  _showFaqAnswer(icon, answer) {
    answer.classList.remove("tw-hidden");
    icon.classList.remove("fa-plus");
    icon.classList.add("fa-minus");
  }

  _hideFaqAnswer(icon, answer) {
    answer.classList.add("tw-hidden");
    icon.classList.add("fa-plus");
    icon.classList.remove("fa-minus");
  }
}
